//@ts-ignore
import React from 'react';
import { PopupStyled, InputStyled, TextAreaStyled } from './styled';

export const GetInTouchPopup = ({
  rtl,
  toggleContactPopup,
  translation,
  client,
  phone,
  hideClientContact,
  name,
  agents,
  newLead,
  editLead,
  sendLead,
  legalBookingBox,
  legalBookingBox2
}: any) => {
  return (
    <PopupStyled className={`${rtl ? 'rtl' : ''}`}>
      <div
        className="close"
        onClick={toggleContactPopup}
        role="button"
        tabIndex={0}
        onKeyPress={() => null}
      >
        <i className="fas fa-times" />
      </div>
      <div className="contact-popup-content">
        <h2>{translation && translation.getInTouch}</h2>

        {((client && client.phone) || (phone && name)) && (
          <div className="agent-cards">
            {!hideClientContact &&
              (!phone && !name && client ? (
                <div className="agent-card" style={agents.length < 2 ? { width: '50%' } : {}}>
                  {client.logo && (
                    <div
                      className="img"
                      style={{
                        backgroundSize: 'contain',
                        backgroundImage: `url(${client.logo})`
                      }}
                    />
                  )}
                  <div className="text">
                    <h4>{client.name}</h4>
                    <a href={`tel:${client.phone}`}>{client.phone}</a>
                  </div>
                </div>
              ) : (
                <div className="agent-card">
                  <div className="text">
                    <h4>{name}</h4>
                    <a href={`tel:${phone}`}>{phone}</a>
                  </div>
                </div>
              ))}
            {agents.map((agent: any, i: number) => (
              <div key={i} className="agent-card">
                {agent.logo && (
                  <div
                    className="img"
                    style={{
                      backgroundImage: `url(${agent.logo})`
                    }}
                  />
                )}
                <div className="text">
                  <h4>{agent.name}</h4>
                  <a href={`tel:${agent.phone}`}>{agent.phone}</a>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="input-c left">
          <label>{translation && translation.name}</label>
          <InputStyled
            type="text"
            name="name"
            value={newLead.name ? newLead.name : ''}
            onChange={editLead}
          />
        </div>
        <div className="input-c right">
          <label>{translation && translation.phone}</label>
          <InputStyled
            type="text"
            name="phone"
            value={newLead.phone ? newLead.phone : ''}
            onChange={editLead}
          />
        </div>
        <div className="input-c full">
          <label>{translation && translation.email}</label>
          <InputStyled
            type="text"
            name="email"
            value={newLead.email ? newLead.email : ''}
            onChange={editLead}
          />
        </div>

        <div className="clearfix" />
        <div className="input-c full">
          <label>{translation && translation.message}</label>
          <TextAreaStyled name="message" onChange={editLead}>
            {newLead.message ? newLead.message : ''}
          </TextAreaStyled>
        </div>
        <div className="clearfix" />
        {legalBookingBox && (
          <div className="appointment-block">
            <label>
              <input
                className="block-input"
                type="checkbox"
                name="legalBookingBox"
                value={newLead.legalBookingBox}
                onChange={editLead}
              />
              {legalBookingBox}
            </label>
          </div>
        )}
        <div className="clearfix" />
        {legalBookingBox2 && (
          <div className="appointment-block">
            <label>
              <input
                className="block-input"
                type="checkbox"
                name="legalBookingBox2"
                value={newLead.legalBookingBox2}
                onChange={editLead}
              />
              {legalBookingBox2}
            </label>
          </div>
        )}

        <a className="square-button" onClick={sendLead}>
          {translation && translation.submit}
        </a>
      </div>
    </PopupStyled>
  );
};
